<!--
 * @LastEditors: Yx
 * @LastEditTime: 2022-07-22 09:53:17
 * @Description: 
 * @Author: Yx
 * @Date: 2022-07-20 17:17:07
 * @FilePath: \szjzsoft-framework\src\views\program\components\assetManagement.vue
-->
<template>
  <public-tem :mainTabs="false" :mainBody="false">
    <div slot="topShow">
      <img src="~imgs/case/guanli.jpg" alt="">
    </div>
  </public-tem>
</template>

<script>
import publicTem from "@/components/publicTemplate/index";
export default {
  name: "assetManagement",
  components: {
    publicTem
  },
  data() {
    return {
      // advList: []
    };
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>

<style scoped>
</style>
